// main.js
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import ElementUI from 'element-ui';
Vue.use(ElementUI);
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// 导入全局 CSS 文件
import '@fortawesome/fontawesome-free/css/all.css';
import '@/styles/main.css';

Vue.config.productionTip = false

//获取用户浏览器的默认语言
const userLanguage = navigator.language || navigator.userLanguage;

// 设置 i18n 的默认语言为用户浏览器的语言
if (userLanguage !== 'en' && userLanguage !== 'zh-CN') {
  i18n.locale = 'en';
} else {
  i18n.locale = userLanguage;
}

// 定义全局方法 scrollToSection
Vue.prototype.$scrollToSection = function (link) {
  const section = document.getElementById(link);
  section.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app');
